import * as utils from './Utils';


export function convertProductCurrency(product) {
  if (typeof Currency !== 'undefined' && Currency.convertAll) {
    if (product.currency !== Currency.currentCurrency) {
      Currency.convertAll(product.currency, Currency.currentCurrency, "span.money", Currency.format);
    }

    return;
  }

  if (typeof EasyStore !== 'undefined' && EasyStore.Currencies) {
    if (product.currency !== EasyStore.Currencies.current_currency) {
      let defaultIsServerSideConversion = EasyStore.Currencies.is_server_side_currency_conversion;
      EasyStore.Currencies.is_server_side_currency_conversion = 0;
      let e = document.querySelectorAll(".ov-app-recommender span.money");
      for (let t of e) {
        t.innerHTML = EasyStore.Currencies.formatMoney(100 * Number(t.getAttribute("data-ori-price").replace(/,/g, "")));
      }
      EasyStore.Currencies.is_server_side_currency_conversion = defaultIsServerSideConversion;
    }
  }
}

export function transformProductPriceOutput(output) {
  // add `data-ori-price` and convert if required
  try {
    let htmlDoc = new DOMParser().parseFromString(output, 'text/xml');
    htmlDoc.querySelectorAll("span.money").forEach((el) => {
      let rowText = el.textContent || el.innerHTML;
      if (!rowText) return;

      let oriPrice = el.getAttribute('data-ori-price');
      if (oriPrice) return;

      let rowCurrency = el.getAttribute('data-currency');
      if (!rowCurrency) return;

      let elPrice = parseFloat(rowText.replace(/[^0-9.]/g, ''));
      elPrice = utils.formatMoney(elPrice, rowCurrency, {
        withPrefix: false,
        withTrailingZeros: true,
      });

      el.setAttribute("data-ori-price", elPrice);
    })

    output = htmlDoc.documentElement.outerHTML;
  } catch(error) {
    if (utils.isClientProduction()) console.error(error);
    return output;
  }

  return output;
}
